import {computed, ref} from 'vue';
import {getRouter} from '@/router';

import antMessage from '@/assets/ant/message';

import {createOpenObjectHandler} from './handlers/openObjectHandler';
import {createOpenUrlHandler} from './handlers/openUrlHandler';
import type {INotificationHandler} from './types';

const handlers: INotificationHandler[] = [];

const registerNotificationHandler = (handler: INotificationHandler) => {
  handlers.unshift(handler);
};

export const useNotificationStateHook = () => {
  const unreadCount = ref<number>(0);

  const getUnreadCount = computed(() => unreadCount.value);

  const handleMessage = async (event: MessageEvent) => {
    const message = event.data;

    if (!message) return;

    if (message.type === 'NEW_NOTIFICATIONS') {
      console.log('New notifications received', message);
      return;
    }

    if (message.type === 'UNREAD_COUNT') {
      unreadCount.value = message.count;
      return;
    }

    if (
      message.type === 'ENTRY_SAVED' ||
      message.type === 'NOTIFICATION_ACTION'
    ) {
      const action = message.action || '';

      for (const handler of handlers) {
        if (handler.canHandle(action, message)) {
          const handled = await handler.handle(message);
          if (handled) {
            console.log(
              'Message handled by',
              handler.constructor.name || 'handler',
              {message},
            );
            return;
          }
        }
      }
    }

    if (
      message.type === 'NOTIFICATION_ACTION' &&
      message.action === 'open_object'
    ) {
      const objectId = message.params?.object_id as string | undefined;
      if (!objectId) {
        console.error('Notification action: object_id missing', message);
        return;
      }

      const route = getRouter()?.currentRoute.value;
      if (route?.name === 'MapPage') {
        antMessage.warning(
          `Объект с ID ${objectId} не найден в загруженных слоях`,
        );
      }
      console.warn('Feature not found or not on map page', {
        objectId,
        routeName: route?.name,
      });
    }
  };

  const resetUnreadCount = () => {
    unreadCount.value = 0;
  };

  return {
    getUnreadCount,
    handleMessage,
    resetUnreadCount,
  };
};

registerNotificationHandler(createOpenObjectHandler());
registerNotificationHandler(createOpenUrlHandler());

export const notificationState = useNotificationStateHook();
export {registerNotificationHandler};
